import dayjs from "dayjs";

import { whatsappUrl } from "../../config/contact";
import { formatCurrency } from "./format";
import { clampText, MAX_FLIGHT_LENGTH, MAX_NAME_LENGTH, MAX_NOTES_LENGTH, onlyDigits } from "./text";
import { QuoteInput, QuoteResult } from "./types";

const REASON_TEXT: Record<NonNullable<QuoteResult["reason"]>, string> = {
  unknown_place: "destino fora da tabela",
  no_route: "trajeto sem tarifa cadastrada",
  pax_out_of_range: "quantidade de passageiros acima da tabela",
  invalid_passengers: "quantidade de passageiros não informada",
};

/** Mensagem em PT para o atendente. Sempre texto puro, sem markup. */
export function buildWhatsAppMessage(input: QuoteInput, result: QuoteResult): string {
  const lines: string[] = ["Olá! Fiz uma simulação no site da MB Floripa Turismo:", ""];

  const origin = result.origin?.name || clampText(input.originText, MAX_NAME_LENGTH);
  const destination =
    result.destination?.name || clampText(input.destinationText, MAX_NAME_LENGTH);

  if (origin) lines.push(`📍 Origem: ${origin}`);
  lines.push(`🏁 Destino: ${destination || "não informado"}`);
  lines.push(`👥 Passageiros: ${Math.max(1, Math.floor(input.passengers || 1))}`);
  lines.push(`🔁 Ida e volta: ${input.roundTrip ? "sim" : "não"}`);

  if (input.date) {
    lines.push(`📅 Data: ${dayjs(input.date).format("DD/MM/YYYY [às] HH:mm")}`);
  }

  const flight = clampText(input.flight, MAX_FLIGHT_LENGTH);
  if (flight) lines.push(`✈️ Voo: ${flight}`);

  const extras = result.lines.filter((l) => l.kind === "extra").map((l) => l.label);
  if (extras.length) lines.push(`➕ Adicionais: ${extras.join(", ")}`);

  if (result.status === "ok") {
    lines.push(`💰 Estimativa: ${formatCurrency(result.total, result.currency)}`);
  } else {
    const reason = result.reason ? REASON_TEXT[result.reason] : "sem tarifa";
    lines.push(`💰 Valor: sob consulta (${reason})`);
  }

  const name = clampText(input.name, MAX_NAME_LENGTH);
  const phone = onlyDigits(input.phone);
  const notes = clampText(input.notes, MAX_NOTES_LENGTH);

  if (name || phone || notes) lines.push("");
  if (name) lines.push(`Nome: ${name}`);
  if (phone) lines.push(`Telefone: ${phone}`);
  if (notes) lines.push(`Obs.: ${notes}`);

  return lines.join("\n");
}

export const buildWhatsAppUrl = (number: string, message: string) =>
  whatsappUrl(number, message);
